import React from 'react';
import { Button } from "@sgi/gravity/Button";
import { useRedirectToMySGI } from "../../Custom Hooks/useRedirectToMySGI";
import type { SpaceProps } from "@chakra-ui/react";

type CancelButtonProps = SpaceProps & {
  cancelHandler?: () => void;
}

const CancelButton: React.FC<CancelButtonProps> = ({ cancelHandler, ...props }) => {
  const handleCancelClick = useRedirectToMySGI();

  return (
    <Button
      isFullWidth
      data-testid="cancel-button-test"
      onClick={cancelHandler ? cancelHandler : handleCancelClick}
      variant="ghost"
      {...props}
    >
      Cancel
    </Button>
  );
};

export default CancelButton;